import { defaultColumns, defaultSort } from '../../components/todos/columns';

export default {
  state: {
    myTodos: [],
    todos: [],
    totalTodos: 0,
    pageSize: 0,
    currentPage: 1,
    tableConfig: null,
    loading: false,
    myLoading: false,
    filterString: '',
    sorting: {
      prop: 'deadline',
      order: 'ascending',
    },
  },
  getters: {
    myTodos: state => state.myTodos.filter(todo => todo.status !== 'done'),
    myDoneTodos: state => state.myTodos.filter(todo => todo.status === 'done'),
    todos: state => state.todos,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    myLoading: state => state.myLoading,
  },
  mutations: {
    setTodos(state, todos) {
      state.todos = todos.data;
      state.currentPage = todos.current_page;
      state.pageSize = todos.per_page;
      state.totalTodos = todos.total;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage
    },
    setSorting(state, sorting) {
      state.sorting = {...sorting}
    },
    setFilterString(state, filterString) {
      state.filterString = filterString
    },
    setMyTodos(state, todos) {
      state.myTodos = todos;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setMyLoading(state, loading) {
      state.myLoading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/todo-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'todo-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'todo-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, dispatch, state }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }

        if (queryString) {
          commit('setFilterString', '&' + queryString.substr(1));
          commit('setCurrentPage', 1)
        } else if (queryString === '') {
          commit('setCurrentPage', 1) 
          commit('setFilterString', queryString);
        }

        const sortStr = `&sortby=${state.sorting.prop}&sorttype=${state.sorting.order}`

        const todos = await axios.get('api/todos' + `?page=${state.currentPage}` + sortStr + state.filterString);
        commit('setTodos', todos);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchMyTodos({ commit }) {
      commit('setMyLoading', true);
      try {
        const todos = await axios.get('api/todos/me');
        commit('setMyTodos', todos);
      } catch (e) {
      }
      commit('setMyLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/todos/${id}`);
    },
    async create({ commit }, todo) {
      await axios.post('api/todos', todo);
    },
    async update({ commit }, todo) {
      await axios.put('api/todos', todo);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/todos/${id}`);
    },
  },
};
